'use client'

import { useState, useEffect, useCallback } from 'react'
import { setStoredLocale, getInitialLocale } from '@/lib/locale-storage'

export function useLanguageToggle() {
	const [locale, setLocale] = useState<string>('en')
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
		setLocale(getInitialLocale())
	}, [])

	const toggleLocale = useCallback(() => {
		const newLocale = locale === 'en' ? 'de' : 'en'
		setLocale(newLocale)
		setStoredLocale(newLocale)
		window.location.reload()
	}, [locale])

	const changeLocale = useCallback((newLocale: string) => {
		setLocale(newLocale)
		setStoredLocale(newLocale)
		window.location.reload()
	}, [])

	return { locale, toggleLocale, changeLocale, mounted }
}
